import { Component, effect, input, signal } from '@angular/core';
import { ComponentSharedModule } from '@app/modules/component.shared.module';

@Component({
  selector: 'mobi-star-rating',
  imports: [ComponentSharedModule],
  templateUrl: './star-rating.component.html',
  styleUrl: './star-rating.component.scss',
})
export class StarRatingComponent {
  readonly rating = input<number>();
  readonly starSize = input<number>(7);
  readonly showRatingNumber = input(true);
  animatedRating = signal(0);
  readonly isInHeader = input(false);
  #instanceId = Math.random().toString(36).substring(2, 9);

  getStarFill(starPosition: number): number {
    const ratingValue = this.rating() ?? 0;

    if (starPosition <= Math.floor(ratingValue)) {
      return 576;
    } else if (starPosition > Math.ceil(ratingValue)) {
      return 0;
    } else {
      const decimal = ratingValue % 1;
      return Math.round(576 * decimal);
    }
  }

  // Add a method to generate unique clipPath IDs
  getClipPathId(starPosition: number): string {
    return `clip-star-${this.#instanceId}-${starPosition}`;
  }

  getDelay(starPosition: number): string {
    return `${(starPosition - 1) * 120}ms`;
  }

  #animateRating = effect(() => {
    const target = this.rating() ?? 0;
    if (target > 0) {
      this.incrementRating(target);
    } else {
      this.animatedRating.set(0);
    }
  });

  incrementRating(target: number) {
    let current = 0;
    const interval = setInterval(() => {
      if (current >= target) {
        clearInterval(interval);
        this.animatedRating.set(target);
        return;
      }
      current = parseFloat((current + 0.1).toFixed(1));
      this.animatedRating.set(current);
    }, 15);
  }
}
